import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-connection-request-sent',
  templateUrl: './connection-request-sent.component.html',
  styleUrls: ['./connection-request-sent.component.scss']
})
export class ConnectionRequestSentComponent implements OnInit {
  constructor(private activeModal: NgbActiveModal) { }
  @Input() public name;
  @Input() public message;
  ngOnInit() {    
  }
  
  closeDialog() {
    this.activeModal.close();
  }

}
